	<div class="flex justify-content-center p-0">
		<div class="p-col-12 p-md-6 p-lg-3 px-3 py-0">
			<div class="flex justify-content-center p-0">
				<div class="p-col-12 p-md-6 p-lg-3 p-0">
					<h3 >{{ 'h3.settings' | translate }}</h3>
				</div>
			</div>

			<div class="pb-0" *resourceRequired="resource.SUBDIVISION">
				<label>{{ 'h5.division' | translate }}</label>
				<p-select [options]="subDivisions" [(ngModel)]="selectedSub"
							placeholder="{{ 'h5.selectSubDivision' | translate }}"
							(ngModelChange)="changeSubdivision()"
							optionLabel="value">
				</p-select>
			</div>

			<div class="pb-0">
				<label>{{ 'h5.warehouse' | translate }}</label>
				<p-select [options]="warehouses" [(ngModel)]="selectedWarehouse"
							placeholder="{{ 'h5.selectWarehouse' | translate}}"
							(ngModelChange)="changeWarehouse()"
							optionLabel="value">
				</p-select>
			</div>

			<div class="pb-0">
				<label>{{ 'h5.language' | translate }}</label>
				<p-select [options]="languages" [(ngModel)]="selectedLanguage"
							placeholder="{{ 'h5.selectLanguage' | translate }}"
							(ngModelChange)="changeLanguage()"
							optionLabel="name">
				</p-select>
			</div>
		</div>
	</div>
